import styles from "@/styles/Price.module.scss";
import formatPrice from "@/lib/formatPrice";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormatPriceTVOD(_ref) {
  let {
    price,
    ext
  } = _ref;
  return /*#__PURE__*/_jsxs("span", {
    className: `${styles.price} ${styles.tvod}`,
    children: ["\u4FA1\u683C\uFF1A", /*#__PURE__*/_jsxs("span", {
      className: styles.priceNum,
      children: [formatPrice(price), "\u5186"]
    }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
  });
}